import type { AdminRole } from './constants';

/** Admin permissions (BLUEPRINT.md section 10.3). The API enforces; the admin UI only hides. */
export const PERMISSIONS = [
  'stats.view',
  'users.view',
  'users.suspend',
  'users.adjust',
  'topups.manage',
  'withdrawals.manage',
  'markets.manage',
  'markets.resolve',
  'proposals.review',
  'admins.manage',
  'config.manage',
  'audit.viewAll',
  'audit.viewOwn',
  'reconciliation.view',
  'reconciliation.run',
] as const;
export type Permission = (typeof PERMISSIONS)[number];

export const ROLE_PERMISSIONS: Readonly<Record<AdminRole, readonly Permission[]>> = {
  super_admin: PERMISSIONS,
  finance: [
    'stats.view',
    'users.view',
    'users.suspend',
    'topups.manage',
    'withdrawals.manage',
    'audit.viewOwn',
    'reconciliation.view',
  ],
  moderator: [
    'stats.view',
    'markets.manage',
    'markets.resolve',
    'proposals.review',
    'audit.viewOwn',
  ],
};

export function can(role: AdminRole, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}
